import { html } from '@design.estate/dees-element';

const logResponse = (event: CustomEvent) => {
  console.log('harness-permission-response', event.detail);
};

export const demoFunc = () => html`
  <style>
    .permissionDemo {
      display: grid;
      gap: 16px;
      max-width: 640px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-primary);
    }
  </style>
  <div class="permissionDemo" @harness-permission-response=${logResponse}>
    <dees-harness-permission-card
      .request=${{
        id: 'p1',
        title: 'Run shell command',
        type: 'shell',
        createdAt: Date.now(),
        metadata: { command: 'rm -rf node_modules && pnpm install', cwd: '/srv/app' },
      }}
    ></dees-harness-permission-card>
    <dees-harness-permission-card
      .request=${{
        id: 'p2',
        title: 'Write file',
        type: 'write',
        metadata: { path: '/srv/app/src/config.ts', bytes: 812 },
      }}
    ></dees-harness-permission-card>
    <dees-harness-permission-card
      busy
      .request=${{
        id: 'p3',
        title: 'Navigate browser',
        type: 'browser',
        metadata: { action: 'navigate', url: 'https://admin.example.com' },
      }}
    ></dees-harness-permission-card>
  </div>
`;
